// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Visibility } from '../../types/Model';

export interface PostCreateCouponRequestPayload {
  isEdit: boolean;
  id: number;
  code: string;
  off: number;
  minus: number;
  onlineCourseIds: number[];
  name: string;
  count: number;
  start: Date;
  end: Date;
  visibility: Visibility;
  success: () => void;
}

export interface PostCreateCouponSuccessPayload {}

export interface PostCreateCouponFailPayload {
  error: Error;
}

export const postCreateCouponActions = createAsyncAction(
  'elearning/POST_CREATE_COUPON',
  'elearning/POST_CREATE_COUPON_SUCCESS',
  'elearning/POST_CREATE_COUPON_FAIL'
)<
  PostCreateCouponRequestPayload,
  PostCreateCouponSuccessPayload,
  PostCreateCouponFailPayload
>();
